import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .service('createComfortBidService', createComfortBidService);

    function createComfortBidService() {
        //if Wizard is called from dashboard
        var networkPoint;

        return {
            setNetworkPoint: setNetworkPoint,
            getNetworkPoint: getNetworkPoint
        };

        function setNetworkPoint(netPoint) {
            networkPoint = netPoint;
        }

        function getNetworkPoint() {
            return networkPoint;
        }
    }
})();
